import { baseApi } from '../baseApi';
import { AcademicYear, ListParams } from './academicYearApi';

export interface Subject {
  id: string;
  name: string;
  icon?: string | null;
  color?: string | null;
  price: number;
  isActive: boolean;
  academicYearId: string;
  classId: string;
  createdAt: string;
  updatedAt: string;
  academicYear?: {
    name: string;
  };
}

export const subjectApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubjects: builder.query<{ success: boolean; data: Subject[]; total: number; page: number; limit: number }, ListParams | void>({
      query: (params) => ({
        url: '/api/subjects',
        params: params || undefined,
      }),
      providesTags: ['Subject'],
    }),
    createSubject: builder.mutation<{ success: boolean; data: Subject }, Partial<Subject>>({
      query: (body) => ({
        url: '/api/subjects',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Subject', 'Dashboard'],
    }),
    updateSubject: builder.mutation<{ success: boolean; data: Subject }, { id: string; body: Partial<Subject> }>({
      query: ({ id, body }) => ({
        url: `/api/subjects/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Subject', 'Dashboard'],
    }),
    deleteSubject: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/subjects/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Subject', 'Dashboard'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSubjectsQuery,
  useCreateSubjectMutation,
  useUpdateSubjectMutation,
  useDeleteSubjectMutation,
} = subjectApi;
